.wrapper {
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
	width: 100%;
}

.iconBtn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border: 1px solid var(--ai-border, #e5e7eb);
	border-radius: 8px;
	background: var(--ai-bg, #fff);
	cursor: pointer;
	transition:
		transform 0.12s ease,
		background 0.12s ease,
		box-shadow 0.12s ease;
	flex-shrink: 0;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	}
	&:active {
		transform: none;
	}
	&:focus-visible {
		outline: 2px solid #84bd44;
		outline-offset: 2px;
	}
}

.productName {
	font-size: 14px;
	line-height: 1.3;
	color: var(--ai-text, #111827);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
	flex: 1;
	font-weight: 500;
}
